<template>
  <Select v-model="selectedValue">
    <SelectTrigger>
      <div class="flex gap-2 text-primary font-medium">
        <slot name="icon"></slot>
        <SelectValue :placeholder="placeholder" />
      </div>
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        <SelectItem
          v-for="item in options"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>

<script setup>
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/Shadcn/Components/ui/select";

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: () => {
      const { t } = useI18n();
      return t("components.buttons.make_selection");
    },
  },
});

const emit = defineEmits(["update:modelValue"]);

const selectedValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newValue) => {
    selectedValue.value = newValue;
  }
);

watch(selectedValue, (newValue) => {
  emit("update:modelValue", newValue);
});
</script>
